import React, { useState, useCallback, useEffect } from 'react';
import { debounce } from 'lodash';
import { Search } from '@spark';

export const RequestExampleSearchInput = ({
    onSearch,
    placeholder = "Search examples",
    disabled = false,
    value = '',
}) => {
    // Parent filters survive tab unmount; local state does not. Seed from `value`
    // so a remount still shows the query that is actually filtering the table.
    const [searchValue, setSearchValue] = useState(value);

    useEffect(() => {
        setSearchValue(value ?? '');
    }, [value]);

    const debouncedSearch = useCallback(
        debounce((value) => {
            onSearch(value);
        }, 700),
        [onSearch]
    );

    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    const handleChange = useCallback((e) => {
        const value = e.target.value;
        setSearchValue(value);
        if (value === '') {
            debouncedSearch.cancel();
            onSearch('');
        } else {
            debouncedSearch(value);
        }
    }, [debouncedSearch, onSearch]);

    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            debouncedSearch.cancel();
            onSearch(searchValue);
        }
    }, [debouncedSearch, searchValue, onSearch]);

    const handleClear = useCallback(() => {
        setSearchValue('');
        debouncedSearch.cancel();
        onSearch('');
    }, [debouncedSearch, onSearch]);

    return (
        <Search
            size="small"
            placeholder={placeholder}
            value={searchValue}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            showClearButton
            onClear={handleClear}
            disabled={disabled}
            autoFocus
            style={{ maxWidth: 500, minWidth: 200 }}
        />
    );
};
